import ComboBox from "./ComboBox";
import { INDUSTRIES } from "../constants/industries";
import { UNIVERSITIES } from "../constants/universities";

export const EMPTY_PRIVATE_CONTACT_PROFILE = Object.freeze({
  role: "",
  company: "",
  organization: "",
  industry: "",
  school: "",
  location: "",
  email: "",
});

export default function PrivateContactFields({
  name,
  onNameChange,
  value,
  onChange,
  disabled = false,
  idPrefix = "private-contact",
}) {
  const profile = { ...EMPTY_PRIVATE_CONTACT_PROFILE, ...(value || {}) };
  const update = (field, nextValue) => onChange?.({ ...profile, [field]: nextValue });

  return (
    <section className="private-contact-card" aria-labelledby={`${idPrefix}-title`}>
      <div className="private-contact-card-header">
        <div>
          <h4 id={`${idPrefix}-title`}>Private contact details</h4>
          <p>Add what you know so this person is easier to recognize and search.</p>
        </div>
        <span className="private-contact-badge">Only you</span>
      </div>

      <div className="private-contact-grid">
        <div className="form-field private-contact-name-field">
          <label htmlFor={`${idPrefix}-name`}>Full name</label>
          <input
            id={`${idPrefix}-name`}
            type="text"
            placeholder="Full name"
            value={name}
            onChange={(event) => onNameChange?.(event.target.value)}
            disabled={disabled}
          />
        </div>
        <div className="form-field">
          <label htmlFor={`${idPrefix}-role`}>Role</label>
          <input
            id={`${idPrefix}-role`}
            type="text"
            placeholder="e.g. Product manager"
            value={profile.role}
            onChange={(event) => update("role", event.target.value)}
            disabled={disabled}
          />
        </div>
        <div className="form-field">
          <label htmlFor={`${idPrefix}-company`}>Company</label>
          <input
            id={`${idPrefix}-company`}
            type="text"
            placeholder="e.g. Acme"
            value={profile.company}
            onChange={(event) => update("company", event.target.value)}
            disabled={disabled}
          />
        </div>
        <div className="form-field">
          <label htmlFor={`${idPrefix}-industry`}>Industry</label>
          <ComboBox
            id={`${idPrefix}-industry`}
            value={profile.industry}
            onChange={(nextValue) => update("industry", nextValue)}
            options={INDUSTRIES}
            placeholder="e.g. Finance"
            disabled={disabled}
          />
        </div>
        <div className="form-field">
          <label htmlFor={`${idPrefix}-organization`}>Organization or fraternity</label>
          <input
            id={`${idPrefix}-organization`}
            type="text"
            placeholder="e.g. Alpha Phi Alpha"
            value={profile.organization}
            onChange={(event) => update("organization", event.target.value)}
            disabled={disabled}
          />
        </div>
        <div className="form-field">
          <label htmlFor={`${idPrefix}-school`}>School</label>
          <ComboBox
            id={`${idPrefix}-school`}
            value={profile.school}
            onChange={(nextValue) => update("school", nextValue)}
            options={UNIVERSITIES}
            placeholder="e.g. Cornell University"
            disabled={disabled}
          />
        </div>
        <div className="form-field">
          <label htmlFor={`${idPrefix}-location`}>Location</label>
          <input
            id={`${idPrefix}-location`}
            type="text"
            placeholder="e.g. Chicago, IL"
            value={profile.location}
            onChange={(event) => update("location", event.target.value)}
            disabled={disabled}
          />
        </div>
        <div className="form-field">
          <label htmlFor={`${idPrefix}-email`}>Email</label>
          <input
            id={`${idPrefix}-email`}
            type="email"
            placeholder="name@example.com"
            value={profile.email}
            onChange={(event) => update("email", event.target.value)}
            disabled={disabled}
          />
        </div>
      </div>
    </section>
  );
}
